import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function() {
    'use strict';

    angular.module('app').component('apply', {
        template: require('./apply.html'),
        controller: ApplyCtrl,
        controllerAs: 'vm'
    });

    ApplyCtrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        '$rootScope',
        'ModalService',
        'QueryService',
        'SessionService',
        '$timeout',
        'logger',
        'Upload'
    ];

    function ApplyCtrl(
        $scope,
        $state,
        $stateParams,
        $location,
        $rootScope,
        ModalService,
        QueryService,
        SessionService,
        $timeout,
        logger,
        Upload
    ) {
        var vm = this;
        vm.isPassword = false;
        vm.brand = require('Images/logo.png');
        vm.logo = require('Images/nav-logo.png');
        vm.mainBackground = require('Images/bunny.png');
        vm.hiring_process = require('Images/HIRING-PROCESS.png');
        vm.tap_image = require('Images/TAP-IMAGE.png');
        vm.qimage = require('Images/7.png');
        vm.requirements_image = require('Images/requirements2.png');
        // The header text on top most of the page

        vm.carousel_images = [
            require('Images/carousel/2.png'),
            require('Images/carousel/4.png'),
            require('Images/carousel/6.png'),
        ];

        vm.perk_image1 = require('Images/perks/1.png');
        vm.perk_image2 = require('Images/perks/2.png');
        vm.perk_image3 = require('Images/perks/3.png');
        vm.perk_image4 = require('Images/perks/4.png');


        vm.carousel_index = parseInt(vm.carousel_images.length*Math.random());

        function start_carousel(){
            vm.carousel_index++;
            vm.carousel_index = (vm.carousel_index) % vm.carousel_images.length;
            setTimeout(()=>{
                $scope.$apply();
                start_carousel()
            }, 8000);
        }
        start_carousel();

        vm.tabs = [
            'Application Portal',
            'Application Process',
            'Basic Requirements',
            'Perks',
            'FAQs'
        ];

        vm.goTop = ()=>{
            window.scroll({
                top: 0, 
                left: 0, 
                behavior: 'smooth'
              });
        }
        setTimeout(()=>{
            vm.goTop();
        }, 200);

        window.onload = ()=> { vm.goTop() }

        vm.tab = vm.tabs[0];

        vm.page = -1;
        vm.years_of_experience = [
            'No experience',
            'Less than a year',
            '1 - 2 years',
            '3 - 5 years',
            '5 years or more'
        ];

        vm.availability = [
            '3-6 hours per day ',
            '8 hours or more per day (I can teach morning and evening classes) ',
            '6 hours per day (peak hours - strictly 6PM to 12 MN)',
            'Others',
        ];

        vm.tags = [
            'OPIc',
            'TOEFL',
            'TOEIC',
            'Business English',
            'English for Traveling',
            'English for Kids',
            'Freetalking',
            'IELTS',
            'Job Interview Training'
        ].map(s => { return { text: s} });

        // setInterval(()=>{
        //     console.log(vm.tags.filter(t => t.clicked).map(t => t.id))
        // }, 1000);

        vm.data = {};
        // vm.data = {
        //     "name":"5","phone":"5555555555","skype_id":"5555555","kakao_id":"5",
        //     "email": Math.random(),"years_of_experience":"Less than a year","availability":
        //     "8 hours or more per day (I can teach morning and evening classes) ","written_input":"5","username":"0shseo","password":"0shseo"
        // }

        // vm.data = {"name":"Redmi Note 8","phone":"1111111111","skype_id":"jdelacruz","kakao_id":"jdelacruz","email":"jdcruz@gmail.com","years_of_experience":"5 years or more","availability":"4-6 hours per day ","written_input":"In light of the recent events regarding the Taal Volcanic Eruption, what do yout think are the measures that one must take in order to be prepared for an emergency?","username":"zb1aa5bq","password":"zb15bq","application_audio":"https://s3.ap-southeast-1.amazonaws.com/media2.daisy152.com/images%2Fcbgfb1vrnb.mp3","tags":["142b45ac-9040-4681-8dc3-d8e9b0040750","836a7048-60e2-4d38-8390-f2088e9a675d"]}


        vm.get_timer = ()=>{

            function pad(num) {
                return ("0"+num).slice(-2);
            }
            function hhmmss(secs) {
              var minutes = Math.floor(secs / 60);
              secs = secs%60;
              var hours = Math.floor(minutes/60)
              minutes = minutes%60;
              return `${pad(minutes)}:${pad(secs)}`;
              // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
            }

            const start = (vm.start.getTime() || 0);
            const end = (vm.end.getTime() || 0);

            return hhmmss(parseInt((20*60*1000 + (start - end))/1000));
        };

        vm.quiz_submitted = 0;
        function update_timer(apply){
            vm.end = new Date();

            if(vm.quiz_submitted){
                return false;
            }

            if(20*60*1000 + (vm.start - vm.end) < 0 ){
                vm.submit_quiz();
                vm.ran_out_of_time = true;
            }else{
                $timeout(()=>{update_timer(1)}, 1000);
            }
            if(apply){
                vm.end = new Date();
                $scope.$apply();
            }
        }

        vm.start_quiz = ()=>{

            update_timer();

            vm.page++;
            vm.start = new Date();
        }
        // vm.start_quiz();

        vm.get_quiz = ()=>{

            vm.loading = true;
            var request = {
                method: 'GET',
                route: URLS.base + `/quiz/teacher`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const quiz = [];
                        const data = response.data.data;
                        for (const key in data) {

                            quiz.push({
                                name: key,
                                items: data[key]
                            });
                            
                        }
                        vm.quiz_number = 0;
                        vm.quiz = quiz[0].items;
                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );
        }

        vm.submit_quiz = ()=>{
            const answers = vm.quiz.map(q => {return { id: q.id, chosen: q.chosen }  });

            console.log(answers);

            vm.loading = true;
            var request = {
                method: 'POST',
                body: {
                    answers
                },
                route: URLS.base + `/quiz/teacher`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data.answers;
                        console.log(data);
                        vm.answers = data;
                        vm.page++;
                        vm.quiz_submitted = 1;

                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );

        };



        // vm.answers = [{"id":"6f13b5ad-0f7c-44ab-9914-8068e92a13a5","chosen":"is","correct":true},{"id":"18f8174c-12dd-4838-876a-91fe5b98edb4","chosen":"ought not to have made","correct":true},{"id":"eaa0fa94-d808-400f-98aa-f3fbf7ebcc34","chosen":"He warned her to shoot if she didn't keep quiet calmly.","correct":false},{"id":"bfb26459-638d-460f-8d0f-9192fced6131","chosen":"er","correct":false},{"id":"db6e2bcb-80e4-4cc1-8566-c041d9a663e4","chosen":"Never has the weather been so bad in the months of June and July.","correct":true}];
        // vm.page = 2;
        
        vm.is_passing = () => {
            return vm.answers.filter(a => !a.correct).length <= 2;
        }
        
        vm.get_tags();
        vm.get_quiz();

        vm.submit = ()=>{
            //preprocessing
            vm.data.username = Math.random().toString(36).substring(7);
            vm.data.password = vm.data.username;
            vm.data.availability += vm.availability_others || '';

            if(!vm.data.application_audio){
                document.getElementById('audio_file').focus();
                logger.error('Please upload an audio file');
            }else{
                vm.data.tags = vm.tags.filter(t => t.clicked).map(t => t.id);


                console.log(vm.data);
                //request
                vm.loaded_limit = false;
                
                vm.loading = true;
                var request = {
                    method: 'POST',
                    body: vm.data,
                    hasFile: false,
                    route: URLS.base + `/teacher`,
                    cache: false
                };

                QueryService.query(request)
                    .then(
                        function(response) {
                            logger.success('Application Sent!');
                            vm.page++;
                            const data = response.data.data;
                            // console.log(data.data.message);
                        },
                        function(error) {
                            // console.log(error);
                            if(error.data.message && error.data.message.includes('uniq_email')){
                                logger.error(`Email is already taken`);

                                document.getElementById('email').focus();

                            }
                        }
                    )
                    .finally(function() {
                        vm.loading = false;
                    });
            }


        }






        vm.upload_audio = file => {
            if (!file) {
                logger.error('Invalid File Type');
            }

            const ext = file.name.split('.').pop();

            var request = {
                method: 'GET',
                route: { upload: ext }
            };
            vm.loading = true;
            QueryService.query(request, {})
                .then(
                    function(response) {
                        upload(response.data.data);
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });

            function upload(data) {
                console.log('data', data);

                request = {
                    method: 'POST',
                    url: data.url,
                    data: {
                        key: data.fields.key,
                        acl: data.fields.acl,
                        AWSAccessKeyId: data.fields.AWSAccessKeyId,
                        Policy: data.fields.policy,
                        Signature: data.fields.signature,
                        success_action_status: 201,
                        'Content-Type': 'image/' + ext,
                        file: file
                    }
                };

                try {
                    Upload.upload(request).then(handle_result, function(
                        error,
                        res
                    ) {
                        logger.error('No!');
                    });
                } catch (e) {
                    console.log(e);
                }
            }
        }

        function handle_result(response) {
            let location = '';
            console.log('response, response', response);

            try {
                location = new DOMParser()
                    .parseFromString(response.data, 'text/xml')
                    .getElementsByTagName('Location')[0].innerHTML;
            } catch (error) {
                logger.error(error);
            }
            vm.data.application_audio = location;
        }








    }
})();



// WEBPACK FOOTER //
// ./src/app/components/apply/apply.component.js